<p-confirmDialog [closable]="false"></p-confirmDialog>
<p-toast></p-toast>
@if (isLoading$ | async) {
  <cv-loader text="Loading, please wait. . ."></cv-loader>
} @else {
  <router-outlet></router-outlet>
}
